export class Point {
    constructor(x, y, index) {
        this.x = x;
        this.y = y;
        this.index = index;
    }
}
//# sourceMappingURL=point.js.map